require("./transferSuccessStep.scss");

// @ vendors
const React = require("react");
const PropTypes = require("prop-types");

// @ helpers
const { FormattedText, formatText } = require("core/i18n").i18n;
const { toCamelCase, getLastNChars } = require("utilities/stringHelper");
const { formatIbanString } = require("commonsUtilities/stringHelper");
const { formatAmount, formatCurrency } = require("utilities/currencyHelper");
const { isSepa } = require("utilities/transfersHelper");
const DateHelper = require("utilities/dateHelper");
const {
    buildCustomPeriodicityText
} = require("utilities/contactCenter/transfersHelper");
const { recordPath, PROC_END } = require("utilities/tagging");

// @ components
const WizardSuccess = require("components/commons/wizardSuccess/wizardSuccess");
const OKInformativeList = require("components/rebrand/OKInformativeList/OKInformativeList");
const OKInformativeListItem = require("components/rebrand/OKInformativeListItem/OKInformativeListItem");
const { OKIconButton } = require("commonsComponents/OKIconButton");
const { OKMessage } = require("commonsComponents/OKMessage");
const OKTooltip = require("components/commons/OKTooltip/OKTooltip");
const { OKSharedSocial } = require("commonsComponents/OKSharedSocial");

// @ utilities
const { changeBiocatchContext } = require("utilities/biocatch");

// @ constants
const {
    DATE_FORMAT_ES,
    FIRST_STEP,
    HYPHEN,
    PERIODICITY_COUNT,
    PERIODICITY_DATE,
    PERIODICITY_CONSTANTLY,
    TRANSFER_EMITTED_DAY_BEFORE,
    TRANSFER_EMITTED_DAY_AFTER,
    BENEFICIARY_TYPE_NGO
} = require("constants/index");
const { catalogue, analyticsId } = require("../analytics/transferStepsAnalytics");

const biocatch = require("constants/biocatch");

const { getSocialShareSolidarity } = require("constants/socialShare");

const classPrefix = "transferSuccessful";

// @Contact Center
const {
    CC_PERIODICITY_CUSTOM,
    CC_TRANSFER_TYPE_PAYROLL
} = require("constants/contactCenter/transfers");

class TransferSuccessStep extends React.Component {
    componentDidMount() {
        const beneficiaryType = this.props.immTransferState.getIn([
            "steps",
            0,
            "beneficiary",
            "type"
        ]);
        this.props.willLeave();
        this.handleDownloadBtnClick = this.handleDownloadBtnClick.bind(this);

        if (beneficiaryType === BENEFICIARY_TYPE_NGO) {
            recordPath(
                window.location.pathname,
                "proc-transferencia-solidaria",
                PROC_END
            );
        }
    }

    handleDownloadBtnClick() {
        // For some reason, when the request fails it doesn't run the catch that sets
        // fetchingPdf to false in emitedTransfersDetails.js. The failure is due to the
        // arraybuffer responseType of the request, but it can't be deleted or the .pdf breaks
        this.props.newTransferGetPdf(
            formatText("transfersEmited-receiptFileName")
        );
    }

    buildPdfButtonSection() {
        const { immBeneficiary, immTransferState } = this.props;
        const reference = immTransferState.get("referenceNumber");
        const isInsideSepa = isSepa(
            immBeneficiary.get("country"),
            immBeneficiary.get("currency")
        );
        const referenceProduct = reference.substring(8, 11);

        let pdfContent;
        // referenceProduct 696 indicates is a no sepa transfer
        if (!!reference && isInsideSepa && referenceProduct !== "696") {
            const button = (
                <div className="transfers-success-step__pdf-button">
                    <OKIconButton
                        icon="icon-descargar"
                        onClick={this.handleDownloadBtnClick}
                    />
                </div>
            );

            pdfContent = (
                <div className="transfers-success-step__pdf-section">
                    <OKTooltip
                        content="transfersEmited-receiptDownload"
                        offset={[0, -15]}
                        target={button}
                        type="descriptive"
                    />
                </div>
            );
        }

        return pdfContent;
    }

    buildSocialShareBox = () => {
        const beneficiaryType = this.props.immTransferState.getIn([
            "steps",
            0,
            "beneficiary",
            "type"
        ]);

        if (!__CONTACT_CENTER__ && beneficiaryType === BENEFICIARY_TYPE_NGO) {
            return <OKSharedSocial {...getSocialShareSolidarity()} />;
        }

        return null;
    };

    buildMessageEditBeneficiarySuccess() {
        const { immBeneficiary, immTransferState } = this.props;
        const isEditingBeneficiaryExisting = immBeneficiary.get(
            "isEditingBeneficiaryExisting"
        );
        const editBeneficiarySuccessful = immTransferState.get(
            "editBeneficiarySuccessful"
        );
        let messageContent;

        if (isEditingBeneficiaryExisting) {
            if (editBeneficiarySuccessful) {
                messageContent = (
                    <div className="row no-outside-gutter transfers-success-step__message-edition-successfull">
                        <OKMessage type="important">
                            <FormattedText value="transferSummary-step2BeneficiarySuccessEditionMsg" />
                        </OKMessage>
                    </div>
                );
            } else {
                messageContent = (
                    <div className="row no-outside-gutter transfers-success-step__message-edition-successfull">
                        <OKMessage type="important">
                            <FormattedText value="transferSummary-step2BeneficiaryErrorEditionMsg" />
                        </OKMessage>
                    </div>
                );
            }
        }

        return messageContent;
    }

    buildPeriodicityLimit() {
        const firstStep = this.props.immTransferState.get("steps").get(0);
        let text;

        if (firstStep.get("periodicityEnabled")) {
            const periodicityType = firstStep.get("periodicityType");

            switch (periodicityType) {
                case PERIODICITY_COUNT:
                    const count = firstStep.get("periodicityCount");
                    const translationText =
                        count === 1
                            ? "step2InfoMsgRepetitionsCountSingular"
                            : "step2InfoMsgRepetitionsCount";
                    text = formatText(`transferSummary-${translationText}`, [
                        count
                    ]);
                    break;
                case PERIODICITY_DATE:
                    const dateHumanReadable = DateHelper.buildFormattedDate(
                        firstStep.get("periodicityDate"),
                        DATE_FORMAT_ES
                    );
                    text = formatText("transferSummary-step2RepeatUntil", [
                        dateHumanReadable
                    ]);
                    break;
                case PERIODICITY_CONSTANTLY:
                    text = formatText("periodicity-constantly");
                    break;
            }
        }

        return text ? <p>{text}</p> : false;
    }

    buildPeriodicityNonWorkableDay() {
        const firstStep = this.props.immTransferState.get("steps").get(0);
        let text;

        if (firstStep.get("periodicityEnabled")) {
            const periodicityTreatmentNonWorkableDay = firstStep.get(
                "periodicityTreatmentNonWorkableDay"
            );

            if (
                periodicityTreatmentNonWorkableDay ===
                TRANSFER_EMITTED_DAY_BEFORE
            ) {
                text = formatText("transferSummary-step2EmittedDayBefore");
            } else if (
                periodicityTreatmentNonWorkableDay ===
                TRANSFER_EMITTED_DAY_AFTER
            ) {
                text = formatText("transferSummary-step2EmittedDayAfter");
            }
        }

        return text ? <p>{text}</p> : false;
    }

    buildPeriodicityText() {
        const firstStep = this.props.immTransferState.get("steps").get(0);
        const rangeType = firstStep.get("periodicityRange").toLowerCase();
        const periodicityRange = firstStep.get("periodicityRange");
        return __CONTACT_CENTER__ && periodicityRange === CC_PERIODICITY_CUSTOM
            ? buildCustomPeriodicityText(firstStep)
            : formatText(`periodicity-${rangeType}`);
    }

    buildTransferEmitter(emitter, immAccount) {
        const code = parseInt(emitter.split(HYPHEN)[1]);
        const immInterveners = immAccount.getIn(["interveners", "list"]);
        const immSelectedIntervener = immInterveners.find(immIntervener => {
            return immIntervener.getIn(["identification", "code"]) === code;
        });

        return immSelectedIntervener
            ? `${immSelectedIntervener.get(
                  "name"
              )} (${immSelectedIntervener.get("type")})`
            : "";
    }

    buildTitleWizard() {
        const { immTransferState } = this.props;

        const firstStep = immTransferState.get("steps").get(0);
        const isToday = firstStep.get("isToday");
        const isImmediate = immTransferState.get("doTransferImmediate");
        let title;

        if (isImmediate) {
            title = formatText(classPrefix + "-immediateTransfer");
        } else if (isToday) {
            title = formatText(classPrefix + "-title");
        } else {
            title = formatText(classPrefix + "-futureTitle");
        }

        return title;
    }

    buildTransferType() {
        if (!__CONTACT_CENTER__) return null;

        const { isTransferTypeChangeEnabled, immTransferState } = this.props;

        if (!isTransferTypeChangeEnabled()) return null;

        const immFirstStep = immTransferState.getIn(["steps", FIRST_STEP]);
        const transferType =
            immFirstStep.get("transferType") === CC_TRANSFER_TYPE_PAYROLL
                ? formatText("transferSuccessful-transferTypePayroll")
                : formatText("transferSuccessful-transferTypeOrdinary");

        return (
            <OKInformativeListItem
                title="transferSuccessful-transferTypesTitle"
                bodyText={transferType}
            />
        );
    }

    render() {
        const {
            immAccounts,
            immBankEntity,
            immBeneficiary,
            immTransferState,
            originAccount,
            transferPayerName
        } = this.props;
        const firstStep = immTransferState.get("steps").get(0);
        const referenceNumber = immTransferState.get("referenceNumber");
        const reference = referenceNumber
            ? formatText(classPrefix + "-reference", [referenceNumber])
            : "";
        const toName =
            toCamelCase(immBeneficiary.get("name")) ||
            immBeneficiary.get("alias");
        const fromIBAN = getLastNChars(originAccount.get("iban"));
        const toIBAN =
            immBeneficiary.get("iban") || immBeneficiary.get("accountNumber");
        const toIBANFormatted = formatIbanString(toIBAN);
        const concept = firstStep.get("concept") || HYPHEN;
        const email = firstStep.getIn(["beneficiary", "email", "value"]);
        const amount = formatAmount(firstStep.get("amount"));
        const date = DateHelper.buildFormattedDate(
            firstStep.get("date"),
            DATE_FORMAT_ES
        );
        const title = this.buildTitleWizard();
        const isImmediate = immTransferState.get("doTransferImmediate");
        const isToday = firstStep.get("isToday");
        const goBackButton = {
            label: formatText("transferSuccessful-back"),
            url: "/myprofile/transfers"
        };
        const pdfButtonSection = this.buildPdfButtonSection();
        const alias =
            originAccount.get("alias") ||
            toCamelCase(originAccount.get("accountType"));
        const fromAccount = `${alias} ${fromIBAN}`;
        const periodicityEnabled = firstStep.get("periodicityEnabled");
        const hasRepetitions = periodicityEnabled
            ? this.buildPeriodicityText()
            : formatText("transferSummary-step2NoRepetitions");
        const periodicityLimit = this.buildPeriodicityLimit();
        const periodicityNonWorkableDay = this.buildPeriodicityNonWorkableDay();
        const isInsideSepa = isSepa(
            immBeneficiary.get("country"),
            immBeneficiary.get("currency")
        );
        const bankName = immBankEntity.get("bankName") || HYPHEN;

        let bankEntity;

        if (isInsideSepa || !!immBeneficiary.get("bic")) {
            bankEntity = (
                <div key={`transferStep2-beneficiary-iban-bankEntity`}>
                    {`(${bankName})`}
                </div>
            );
        }

        const immAccount = immAccounts.get(firstStep.get("fromAccount"));
        const interventionType = formatText(
            `interventionTypes-${immAccount.get("interventionType")}`
        );
        const transferPayer = `${transferPayerName} (${interventionType})`;

        const emitter = firstStep.get("emitter");
        const transferEmitter = !!emitter
            ? this.buildTransferEmitter(emitter, immAccount)
            : transferPayer;
        const currencySymbol = formatCurrency(
            immTransferState.getIn(["steps", 0, "fromAccountCurrency"])
        );

        const messageEditBeneficiarySuccess = this.buildMessageEditBeneficiarySuccess();

        let emailSentMsgContent;
        if (!!email && !immTransferState.get("mailError")) {
            emailSentMsgContent = (
                <div className="transfers-success-step__email-section">
                    <FormattedText
                        value="transferSuccessful-emailSentMsg"
                        injectedStrings={[email]}
                    />
                </div>
            );
        }

        const transferType = this.buildTransferType();
        const socialShare = this.buildSocialShareBox();

        changeBiocatchContext(biocatch.SUCCESSFUL_PAYMENT);

        return (
            <div className="transfers-success-step">
                <WizardSuccess
                    successMessage={title}
                    successSubMessage={reference}
                    mainButton={goBackButton}
                    notifyWrapUp={isToday || isImmediate}
                    tealium={catalogue[analyticsId.TRANSFER_WIZARD_SUCCESS]({isImmediate})}
                    isSecondVersion
                >
                    {emailSentMsgContent}

                    <OKInformativeList columns={2}>
                        <OKInformativeListItem
                            title="transferSuccessful-from"
                            bodyText={fromAccount}
                            bodyWordBreak={!__CONTACT_CENTER__}
                        />
                        <OKInformativeListItem
                            title="transferSuccessful-import"
                            bodyText={`${amount.toString()} ${immBeneficiary.get(
                                "currency"
                            )}`}
                        />
                        <OKInformativeListItem
                            title="transferSummary-step2TransferEmitter"
                            bodyText={transferPayer}
                            bodyWordBreak={false}
                        />

                        {transferType}

                        <OKInformativeListItem
                            title="transferSuccessful-beneficiary"
                            bodyText={toName}
                            bodyWordBreak={false}
                        />
                        <OKInformativeListItem
                            title="transferSummary-step2TransferPayer"
                            bodyText={transferEmitter}
                            bodyWordBreak={false}
                        />
                        <OKInformativeListItem
                            title="transferSuccessful-iban"
                            bodyText={toIBANFormatted}
                            onlyChildren={true}
                        >
                            {bankEntity}
                        </OKInformativeListItem>
                        <OKInformativeListItem
                            title="transferSuccessful-concept"
                            bodyText={concept}
                            bodyWordBreak={false}
                        />
                        <OKInformativeListItem
                            title="transferSuccessful-date"
                            bodyText={date}
                        />
                        <OKInformativeListItem />
                        {isImmediate ? (
                            <OKInformativeListItem
                                title="transferSummary-step2IsImmediate"
                                bodyText={`${formatAmount(
                                    immTransferState.get(
                                        "transferImmediateAmount"
                                    )
                                )} ${currencySymbol}`}
                            />
                        ) : (
                            <OKInformativeListItem
                                title="transferSummary-step2Periodicity"
                                bodyText={hasRepetitions}
                            >
                                {periodicityLimit}
                                {periodicityNonWorkableDay}
                            </OKInformativeListItem>
                        )}
                    </OKInformativeList>
                    {messageEditBeneficiarySuccess}
                    {pdfButtonSection}
                    {socialShare}
                </WizardSuccess>
            </div>
        );
    }
}

TransferSuccessStep.propTypes = {
    callback: PropTypes.func,
    immAccounts: PropTypes.object,
    immBankEntity: PropTypes.object,
    immBeneficiary: PropTypes.object,
    immTransferState: PropTypes.object,
    originAccount: PropTypes.object,
    transferPayerName: PropTypes.string,
    fillForm: PropTypes.func,
    willLeave: PropTypes.func,
    newTransferGetPdf: PropTypes.func,
    isTransferTypeChangeEnabled: PropTypes.func
};

module.exports = TransferSuccessStep;
